<div class="breadcrum">
    <h1>Customers</h1>
    <div style="margin:auto;"></div>
    <ul class="pull-right btn-list">
        <li>
            <button mat-raised-button color="primary" routerLink="/main/AddCustomer">Add Customer</button>
        </li>
    </ul>
</div>
<div class="separator-breadcrumb border-top"></div>
<div class="row">
    <div class="col-md-12">
        <div class="card mb-4">
            <div class="card-body">
                <div class="form">
                    <div class="row">
                        <div class="col-md-12">
                            <div style="display:flex;align-items:center;gap:8px;margin-bottom:16px;">
                              <mat-form-field style="flex:1;max-width:400px;" appearance="outline">
                                <mat-label>Search by Name / Reference / Phone</mat-label>
                                <input matInput #searchInput [value]="searchTerm" (input)="onSearch(searchInput.value)" placeholder="Type to search...">
                                <button *ngIf="searchTerm" matSuffix mat-icon-button (click)="clearSearch()">
                                  <i class="material-icons">close</i>
                                </button>
                                <i matSuffix class="material-icons" *ngIf="!searchTerm" style="color:#aaa;">search</i>
                              </mat-form-field>
                              <span *ngIf="searchTerm" style="color:#666;font-size:13px;">
                                {{ totalRecords }} result(s) for "{{ searchTerm }}"
                              </span>
                            </div>
                            <p *ngIf="isLoading" style="text-align:center;padding:20px;color:#666;">Loading...</p>
                            <div class="table-responsive">
                                <table mat-table [dataSource]="customers">

                                  <ng-container matColumnDef="id">
                                    <th mat-header-cell *matHeaderCellDef> S.No. </th>
                                    <td mat-cell *matCellDef="let element; let i = index;">
                                      {{ currentOffset() + i + 1 }}
                                    </td>
                                  </ng-container>

                                  <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> Name </th>
                                    <td mat-cell *matCellDef="let element"> {{element.CustomerName}} </td>
                                  </ng-container>

                                  <ng-container matColumnDef="phone">
                                    <th mat-header-cell *matHeaderCellDef> Reference No / Docket No </th>
                                    <td mat-cell *matCellDef="let element"> {{element.CustomerRef}} </td>
                                  </ng-container>

                                  <ng-container matColumnDef="ref">
                                    <th mat-header-cell *matHeaderCellDef> Phone No </th>
                                    <td mat-cell *matCellDef="let element"> {{element.CustomerPone}} </td>
                                  </ng-container>

                                  <ng-container matColumnDef="date">
                                    <th mat-header-cell *matHeaderCellDef> Year </th>
                                    <td mat-cell *matCellDef="let element"> {{element.cMonth}} {{element.cYear}} </td>
                                  </ng-container>

                                  <ng-container matColumnDef="edit">
                                    <th mat-header-cell *matHeaderCellDef> Edit </th>
                                    <td mat-cell *matCellDef="let element">
                                        <button mat-stroked-button color="primary" (click)="edit(element.Id)">
                                            <i class="material-icons">create</i>
                                        </button>
                                    </td>
                                  </ng-container>

                                  <ng-container matColumnDef="add">
                                    <th mat-header-cell *matHeaderCellDef> Add Document </th>
                                    <td mat-cell *matCellDef="let element">
                                        <button mat-stroked-button color="primary" (click)="addDocument(element.CustomerID)">
                                            <span class="material-icons">add</span> Document
                                        </button>
                                    </td>
                                  </ng-container>

                                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>

                                <mat-paginator
                                  [length]="totalRecords"
                                  [pageSize]="pageSize"
                                  [pageSizeOptions]="[50, 100, 200, 500]"
                                  showFirstLastButtons>
                                </mat-paginator>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
